import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ImagePreloaderService {
  preloadImages(imageUrls: string[]): Promise<void[]> {
    const promises = [];
    for (const url of imageUrls) {
      const promise = new Promise<void>((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve();
        img.onerror = (error) => reject(error);
        img.src = url;
      });
      promises.push(promise);
    }
    return Promise.all(promises);
  }
}
